import { render, staticRenderFns } from "./PromotionsEditModal.vue?vue&type=template&id=1fa18ec4&scoped=true&"
import script from "./PromotionsEditModal.vue?vue&type=script&lang=js&"
export * from "./PromotionsEditModal.vue?vue&type=script&lang=js&"
import style0 from "./PromotionsEditModal.vue?vue&type=style&index=0&id=1fa18ec4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa18ec4",
  null
  
)

export default component.exports